import React from "react";
import { motion } from "framer-motion";
import Backdrop from "./backdrop";

const dropIn = {
    hidden: {
        scale: 5,
        opacity: 0,
    },
    visible: {
        // y: 0,
        scale: 1,
        opacity: 1,
        transition: {
            duration: 2,
            type: "spring",
            damping: 25,
            stiffnes: 500,
        }
    },
    exit: {
        scale: 0,
        opacity: 0,
    },
}

const Modal = ({ handleClose, text }) => {
    return (
        <Backdrop
            onClick={handleClose}>
            <motion.div
                onClick={(e) => e.stopPropagation()}
                className="bg-[#FFDEE9] min-w-full md:max-w-3xl m-auto rounded-xl p-8 grid items-center"
                variants={dropIn}
                initial="hidden"
                animate="visible"
                exit="exit">

                {text}
                <div className="grid gap-6">
                    <h1 className="font-marck text-3xl">Message</h1>
                    <p className="font-indie text-black text-base">Ini adalah hasil 2-3 hari kerja hehee, Cupcake nya enak terimakasih😃</p>
                    <div>
                        <motion.button
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={handleClose}
                            className="inline-grid bg-[#B5FFFC] px-6 py-2 rounded-lg">
                            Close
                        </motion.button>
                    </div>
                </div>
            </motion.div>
        </Backdrop>
    )
}

export default Modal;